function getWeekParams(date, firstDayOfWeek = 1) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const currentDay = date.getDay();
    const dayOffset = (currentDay - firstDayOfWeek + 7) % 7;

    const startOfWeek = new Date(date);
    startOfWeek.setDate(date.getDate() - dayOffset);
    startOfWeek.setHours(0, 0, 0, 0);

    return { today, startOfWeek };
}

function isToday(date, today = new Date()) {
    return date.getFullYear() === today.getFullYear()
        && date.getMonth() === today.getMonth()
        && date.getDate() === today.getDate();
}

function isWeekend(date) {
    return [0, 6].includes(date.getDay());
}

export function getWeekday(date) {
    return {
        date,
        index:     0,
        isToday:   isToday(date),
        isWeekend: isWeekend(date),
    };
}

export function getWeekdays(date, firstDayOfWeek = 1, noWeekends = false) {
    const { today, startOfWeek } = getWeekParams(date, firstDayOfWeek);

    const days = [];

    for (let i = 0; i < 7; i++) {
        const weekday = new Date(
            startOfWeek.getFullYear(),
            startOfWeek.getMonth(),
            startOfWeek.getDate() + i,
        );

        // eslint-disable-next-line no-continue
        if (noWeekends && isWeekend(weekday)) continue;

        days.push({
            date:         weekday,
            index:        weekday.getDay(),
            isToday:      isToday(weekday, today),
            isWeekend:    isWeekend(weekday),
            isLastColumn: i === 6,
        });
    }

    return days;
}

export function getMonthlyCalendarGrid(date, firstDayOfWeek = 1, noWeekends = false) {
    const cells = [];
    const year = date.getFullYear();
    const month = date.getMonth();

    const today = new Date();
    const startOfMonth = new Date(year, month, 1);

    const rawStartDay = startOfMonth.getDay();
    const startDay = (rawStartDay - firstDayOfWeek + 7) % 7;

    const startDate = new Date(startOfMonth);
    startDate.setDate(startOfMonth.getDate() - startDay);

    const gridSize = 42;

    for (let i = 0; i < gridSize; i++) {
        const date = new Date(
            startDate.getFullYear(),
            startDate.getMonth(),
            startDate.getDate() + i,
        );

        // eslint-disable-next-line no-continue
        if (noWeekends && isWeekend(date)) continue;

        const isCurrentMonth = date.getFullYear() === year && date.getMonth() === month;

        const dayOffset = (date.getDay() - firstDayOfWeek + 7) % 7;
        const isLastColumn = dayOffset === 6;
        const isLastRow = i >= gridSize - 7;

        const xIndex = dayOffset;
        const yIndex = Math.floor(i / 7);

        cells.push({
            date,
            isCurrentMonth,
            isToday:   isToday(date, today),
            isWeekend: isWeekend(date),
            isLastColumn,
            isLastRow,
            xIndex,
            yIndex,
        });
    }

    return cells;
}

export function getWeeklyCalendarGrid(date, firstDayOfWeek = 1, noWeekends = false) {
    const { today, startOfWeek } = getWeekParams(date, firstDayOfWeek);

    const cells = [];

    for (let hour = 0; hour < 24; hour++) {
        for (let day = 0; day < 7; day++) {
            const cellDate = new Date(
                startOfWeek.getFullYear(),
                startOfWeek.getMonth(),
                startOfWeek.getDate() + day,
                hour, 0, 0, 0,
            );

            // eslint-disable-next-line no-continue
            if (noWeekends && isWeekend(cellDate)) continue;

            cells.push({
                date:         cellDate,
                hour,
                dayOfWeek:    cellDate.getDay(),
                isToday:      isToday(cellDate, today),
                isWeekend:    isWeekend(cellDate),
                isLastColumn: day === 6,
                isLastRow:    hour === 23,
                xIndex:       day,
                yIndex:       hour,
            });
        }
    }

    return cells;
}

export function getDailyCalendarGrid(date) {
    const cells = [];

    for (let hour = 0; hour < 24; hour++) {
        const cellDate = new Date(
            date.getFullYear(),
            date.getMonth(),
            date.getDate(),
            hour, 0, 0, 0,
        );

        cells.push({
            date:         cellDate,
            hour,
            dayOfWeek:    cellDate.getDay(),
            isToday:      isToday(cellDate),
            isWeekend:    isWeekend(cellDate),
            isLastColumn: true,
            isLastRow:    hour === 23,
            xIndex:       0,
            yIndex:       hour,
        });
    }

    return cells;
}
